import React from 'react';
import CreateModal from './CreateModal';
import styles from './StripeModal.module.scss';
import clsx from 'clsx';
import StripePaymentForm from 'components/grid/Payment/StripePaymentElement/StripePaymentElement';
import type { UseStateProps } from 'types/generic';
import { CustomerPaymentMethods } from 'types/stripe';
import { useFetcher} from 'utils/fetcher';


type StripeModalProps = {
  mutate?: () => void;
  modalStates: UseStateProps<boolean>;
  rid?: string | number;
};
export default function StripeModal({ mutate, modalStates, rid }: Readonly<StripeModalProps>) {
  const [open, setOpen] = modalStates;
  const [before, setBefore] = React.useState(false);
  const { data, isLoading} = useFetcher<CustomerPaymentMethods>(
    `/api/v2/patient/cards/stripe_customer_payment_methods?request_id=${rid}`,
  );

  React.useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (!before) {
      timeout = setTimeout(() => {
        setBefore(true);
      }, 25);
    }
    return () => clearTimeout(timeout);
  });
  const openStripModal = () =>{
    if(!isLoading && data){
      let crad_length = document.querySelectorAll('.crad_wrapper');
      if(crad_length.length >= 10){
        alert("Alert! - There is a ten card limit for cards on file. Please delete a card to add a new card")
      }else{
        setOpen(true) 
      }
    }
  }

  const Exit = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={styles.exit}
      onClick={() => {
        setOpen(false);
        setTimeout(() => setBefore(false), 1000);
      }}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  );

  return (
    <>
      <div onClick={openStripModal} className={clsx(styles['modalButton'], 'col-12 col-md-6 col-lg-4')}>
        <div className={styles['modalButtonBody']} role="button">
          ADD CARD
        </div>
      </div>
      <CreateModal selector="#stripe-modal" open={before}>
        <div className={clsx(styles['modal'], !open ? styles['invisible'] : '')}>
          <div className={clsx(styles['content'], !open ? styles['content-invisible'] : '')}>
            <Exit />
            <StripePaymentForm mutate={mutate} setOpen={setOpen} rid={rid}/>
          </div>
        </div>
      </CreateModal>
    </>
  );
}
